import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 13,
	viewBox: "0 0 11 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.375 12.125C2.03125 12.125 1.73698 12.0026 1.49219 11.7578C1.2474 11.513 1.125 11.2188 1.125 10.875V2.75H0.5V1.5H3.625V0.875H7.375V1.5H10.5V2.75H9.875V10.875C9.875 11.2188 9.7526 11.513 9.50781 11.7578C9.26302 12.0026 8.96875 12.125 8.625 12.125H2.375ZM8.625 2.75H2.375V10.875H8.625V2.75ZM3.625 9.625H4.875V4H3.625V9.625ZM6.125 9.625H7.375V4H6.125V9.625Z",
		fill: "#1D2D58"
	})
});
export default SvgDelete;
